module.exports = __webpack_public_path__ + "img/Molecule_to_thinking.1da24c46.gif";